export const PAGE_LIMIT = 20;
export const SEARCH_API = '/api/company/search-salary-database';

export const titleFieldLabelProps = {
    label: 'Search by Title',
    shouldShowTooltip: false,
};

export const departmentFieldLabelProps = {
    label: 'Search by department',
    shouldShowTooltip: false,
};

export const TABLE_HEADERS = [
    {
        label: 'Title',
        sortOptions: [
            { label: 'A - Z', value: 'asc' },
            { label: 'Z - A', value: 'desc' },
        ],
        value: 'title',
    },
    {
        label: 'Department',
        sortOptions: [
            { label: 'A - Z', value: 'asc' },
            { label: 'Z - A', value: 'desc' },
        ],
        value: 'department',
    },
    {
        label: 'Salary range',
        sortOptions: [
            { label: 'High - Low', value: 'desc' },
            { label: 'Low - High', value: 'asc' },
        ],
        value: 'salary',
    },
    {
        label: 'Bonus range',
        sortOptions: [
            { label: 'High - Low', value: 'desc' },
            { label: 'Low - High', value: 'asc' },
        ],
        value: 'bonus',
    },
    {
        label: 'Company',
        sortOptions: [
            { label: 'A - Z', value: 'asc' },
            { label: 'Z - A', value: 'desc' },
        ],
        value: 'companyName',
    },
    {
        label: 'Add a Tip',
    },
];

export const THROTTLE_INTERVAL = 200;
